// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-history-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.chat-history-grid {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 20px;
  height: calc(100vh - 100px);
}

.users-list {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 15px;
  overflow: hidden;
}

.users-scroll {
  height: calc(100% - 40px);
  overflow-y: auto;
}

.user-item {
  padding: 15px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  transition: background-color 0.2s;
}

.user-item:hover {
  background-color: #e9e9e9;
}

.user-item.selected {
  background-color: #e0e0e0;
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.history-details {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 15px;
  overflow: hidden;
}

.history-scroll {
  height: calc(100% - 40px);
  overflow-y: auto;
}

.history-item {
  background: white;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.history-timestamp {
  color: #666;
  font-size: 0.9em;
  margin-bottom: 10px;
}

.history-question,
.history-answer {
  margin: 5px 0;
}

.no-history {
  text-align: center;
  padding: 20px;
  color: #666;
}

/* Scrollbar styling */
.users-scroll::-webkit-scrollbar,
.history-scroll::-webkit-scrollbar {
  width: 8px;
}

.users-scroll::-webkit-scrollbar-track,
.history-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.users-scroll::-webkit-scrollbar-thumb,
.history-scroll::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.users-scroll::-webkit-scrollbar-thumb:hover,
.history-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
} `, "",{"version":3,"sources":["webpack://./src/MyComponents/ChatBot/ChatHistory.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,sBAAsB;AACtB;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB","sourcesContent":[".chat-history-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.chat-history-grid {\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  gap: 20px;\n  height: calc(100vh - 100px);\n}\n\n.users-list {\n  background: #f5f5f5;\n  border-radius: 8px;\n  padding: 15px;\n  overflow: hidden;\n}\n\n.users-scroll {\n  height: calc(100% - 40px);\n  overflow-y: auto;\n}\n\n.user-item {\n  padding: 15px;\n  border-bottom: 1px solid #ddd;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.user-item:hover {\n  background-color: #e9e9e9;\n}\n\n.user-item.selected {\n  background-color: #e0e0e0;\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.history-details {\n  background: #f5f5f5;\n  border-radius: 8px;\n  padding: 15px;\n  overflow: hidden;\n}\n\n.history-scroll {\n  height: calc(100% - 40px);\n  overflow-y: auto;\n}\n\n.history-item {\n  background: white;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.history-timestamp {\n  color: #666;\n  font-size: 0.9em;\n  margin-bottom: 10px;\n}\n\n.history-question,\n.history-answer {\n  margin: 5px 0;\n}\n\n.no-history {\n  text-align: center;\n  padding: 20px;\n  color: #666;\n}\n\n/* Scrollbar styling */\n.users-scroll::-webkit-scrollbar,\n.history-scroll::-webkit-scrollbar {\n  width: 8px;\n}\n\n.users-scroll::-webkit-scrollbar-track,\n.history-scroll::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.users-scroll::-webkit-scrollbar-thumb,\n.history-scroll::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.users-scroll::-webkit-scrollbar-thumb:hover,\n.history-scroll::-webkit-scrollbar-thumb:hover {\n  background: #555;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
